"use client";
import { useContext } from "react";
import { AppContext } from "./AppContext";

export default function AnalyzerDots() {
  const { config, duration, animationType } = useContext(AppContext);
  const se = Date.now();
  const style = [];
  const cnt = () => {
    const dots = config.map((k, i) => {
      const { colors, x, y } = k;
      if (colors.length === 1) return [];
      const unit = 100 / (x.length - 1);
      const animationSteps = x.map((xx, u) => {
        const un = parseInt(u * unit);
        return `${un}%{left:${xx};top:${y[u]}}`;
      });

      const id = `dot-${se}-${i}`;
      style.push(`@keyframes ani-${id}{${animationSteps.join(" ")}}`);
      style.push(
        `#${id}{animation:ani-${id} ${duration} linear infinite ${animationType}}`
      );
      return (
        <div
          id={id}
          className="absolute -m-[3px] h-[6px] w-[6px] rounded-full bg-white"
          key={i}
        ></div>
      );
    });

    return (
      <>
        {style.length > 0 && <style>{style}</style>}
        {dots}
      </>
    );
  };

  return <div className="absolute inset-0 z-50">{cnt()}</div>;
}
